module.exports = __webpack_public_path__ + "img/getcode-2.2080831d.png";